import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { AuthenticationService } from '@app/shared/services/authentication.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent {

  constructor(private authenticator: AuthenticationService,
              private router: Router) {
  }

  logout() {
    this.authenticator
      .logout()
      .then(() => {
        this.router.navigate(['/login']);
      });
  }

}
